<span>Componentes: </span>
<div style="display: flex; gap: 10px; flex-wrap: wrap">
  <p-button
    severity="info"
    (click)="openComponentBuilder(lessonComponentEnum.Selector)"
    pTooltip="Agrega un selector con multiples opciones"
    tooltipPosition="bottom">
    Selector
  </p-button>
  <p-button
    severity="info"
    (click)="openComponentBuilder(lessonComponentEnum.Speaker)"
    pTooltip="Para que una palabra o frase sea reproducible"
    tooltipPosition="bottom">
    Speaker
  </p-button>
  <p-button
    severity="info"
    (click)="openComponentBuilder(lessonComponentEnum.TextWriter)"
    pTooltip="Escribe una respuesta en un cuadro de texto"
    tooltipPosition="bottom">
    Text
  </p-button>
  <p-button
    severity="info"
    (click)="openComponentBuilder(lessonComponentEnum.VerbSummary)"
    pTooltip="Muestra la información de un verbo"
    tooltipPosition="bottom">
    Verb
  </p-button>
  <p-button
    severity="info"
    (click)="openComponentBuilder(lessonComponentEnum.WordSummary)"
    pTooltip="Muestra la información de una palabra"
    tooltipPosition="bottom">
    Palabra
  </p-button>
  <p-button
    severity="info"
    (click)="openComponentBuilder(lessonComponentEnum.TranslationSwitcher)"
    pTooltip="Muestra el texto pero al pica cambia de idioma"
    tooltipPosition="bottom">
    Traducción
  </p-button>
  <p-button
    severity="info"
    (click)="openComponentBuilder(lessonComponentEnum.PlayWord)"
    pTooltip="Muestra el texto pero al pica cambia de idioma"
    tooltipPosition="bottom">
    Play Word
  </p-button>
  <!-- Add other buttons here if needed, following the same pattern -->
</div>
